import MasterNoteSectionTable from './MasterNoteSectionTable';
export default MasterNoteSectionTable;
